import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-sm">
                玉
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                玉蒲团文化研究
              </span>
            </div>
            <p className="text-background-300 text-sm leading-relaxed max-w-xs">
              专注华语经典情色文学与电影改编研究的文化平台。我们以学术视角解读经典，以文化关怀传承历史。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              快速导航
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-background-300 hover:text-background-50 text-sm transition-colors">
                首页
              </Link>
              <Link to="/category/wenxue-shangxi" className="text-background-300 hover:text-background-50 text-sm transition-colors">
                文学赏析
              </Link>
              <Link to="/category/dianying-pingxi" className="text-background-300 hover:text-background-50 text-sm transition-colors">
                电影评析
              </Link>
              <Link to="/category/sanjipian-shi" className="text-background-300 hover:text-background-50 text-sm transition-colors">
                三级片文化史
              </Link>
              <Link to="/about" className="text-background-300 hover:text-background-50 text-sm transition-colors">
                关于我们
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              联系我们
            </h4>
            <div className="flex flex-col gap-2.5 text-background-300 text-sm">
              <span>
                <i className="ri-mail-line mr-2"></i>
                contact@ibfdxic.cn
              </span>
              <span>
                <i className="ri-map-pin-line mr-2"></i>
                中国 · 香港
              </span>
              <span className="text-background-400 text-xs mt-2">
                本网站内容仅供学术研究与文化赏析之用
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-400 text-xs">
            &copy; {currentYear} 玉蒲团文化研究中心. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-background-400 text-xs">
            <a href="#" className="hover:text-background-200 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-200 transition-colors">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}